import {Injectable} from '@angular/core';
import {Profile} from './mock-profile';
import {Portfolio} from './mock-portfolio';

@Injectable()
export class PortfolioService {

    constructor() {
    }

    getProfile() {
        return Profile;
    }

    getPortfolio() {
        return Portfolio;
    }

    getPortfolioByName(name: string) {
        return  Portfolio.list.find(
            port => port.img_dir_name === name);
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/profile/portfolio.service.ts